<div class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0">
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>
  <div class="bg-white w-full lg:max-w-screen-lg mx-auto rounded-lg shadow-xl z-50 overflow-y-auto">
    <div class="flex flex-col gap-3 p-5 min-h-[250px]">
      <div class="flex justify-between items-center">
        <h1 class="text-lg font-bold leading-3">Editar dispositivo</h1>

        <button
          type="button"
          class="btn-close"
          aria-label="Fechar formulário"
          routerLink="/dash/dispositivos"
          appCloseOnEscape
        >
          <lucide-icon name="x" [size]="20"></lucide-icon>
        </button>
      </div>

      <form class="flex flex-col gap-5 flex-1" [formGroup]="formDevice">
        <div class="w-full wrapper flex flex-col md:grid">
          <div class="form-group">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="trading"> ID: </label>
            <p class="device-id">{{ deviceId }}</p>
          </div>

          <div class="form-group">
            <label class="block text-gray-700 text-sm font-bold mb-2"> Status: </label>
            <ng-select [searchable]="false" placeholder="Status" formControlName="active">
              <ng-option [value]="true">Ativo</ng-option>
              <ng-option [value]="false">Inativo</ng-option>
            </ng-select>
          </div>

          <div class="form-group" *ngIf="formDevice.get('licenseKey')?.value">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="licenseKey"> Chave de Licença: </label>
            <div class="flex w-full items-center">
              <input type="text" class="form-input w-full" formControlName="licenseKey" readonly />
              <button
                type="button"
                class="ml-2 w-10 h-10 rounded-sm btn--secondary"
                (click)="copyLicenseKey()"
                title="Copiar Chave de Licença"
              >
                <mat-icon>content_copy</mat-icon>
              </button>
            </div>
          </div>

          <div class="form-group" *ngIf="formDevice.get('licenseStatus')?.value">
            <label class="block text-gray-700 text-sm font-bold mb-2">Status:</label>
            <ng-select
              [items]="statusOptions"
              [searchable]="false"
              formControlName="licenseStatus"
              (change)="updateLicenseStatus($event)"
            >
              <ng-template ng-label-tmp let-item="item">
                {{ licenseStatusMap[item] || 'Status Desconhecido' }}
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ licenseStatusMap[item] || 'Status Desconhecido' }}
              </ng-template>
            </ng-select>
          </div>

          <div class="form-group" *ngIf="formDevice.get('licenseKey')?.value">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="expirationDate"> Data de Expiração: </label>
            <div class="flex w-full items-center">
              <input
                type="text"
                class="form-input w-full"
                placeholder="Data de Expiração (Opcional)"
                formControlName="expirationDate"
                [min]="minDate"
                [matDatepicker]="picker"
              />
              <mat-datepicker-toggle class="ml-2" [for]="picker"></mat-datepicker-toggle>
            </div>
            <mat-datepicker #picker></mat-datepicker>
          </div>

          <div class="form-group">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="trading"> Nome: </label>
            <input type="text" class="form-input" placeholder="Nome" formControlName="name" />
          </div>

          <div class="form-group">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="trading"> Identificador do Hardware: </label>
            <input
              type="text"
              class="form-input"
              placeholder="Identificador do Hardware"
              formControlName="hardwareId"
            />
          </div>

          <div class="form-group">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="trading">
              Identificador do Equipamento:
            </label>
            <input
              type="text"
              class="form-input"
              placeholder="Identificador do Equipamento"
              formControlName="equipmentId"
            />
          </div>

          <div class="form-group">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="trading"> Nome do Responsável: </label>
            <input type="text" class="form-input" placeholder="Nome do Responsável" formControlName="contactName" />
          </div>

          <div class="form-group">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="trading"> Contato do Responsável: </label>
            <input
              type="text"
              class="form-input"
              placeholder="Contato do Responsável"
              formControlName="contactPhone"
              mask="(00) 0000-0000||(00) 0 0000-0000"
            />
          </div>

          <div class="form-group">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="trading"> Observação: </label>
            <input type="text" class="form-input" placeholder="Observação" formControlName="observation" />
          </div>

          <div class="form-group">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="trading"> Tipo de dispositivo: </label>
            <ng-select
              notFoundText="Nenhum item encontrado"
              [searchable]="false"
              placeholder="Tipo de dispositivo"
              formControlName="deviceTypeId"
            >
              <ng-option *ngFor="let deviceType of deviceTypes" [value]="deviceType.id">
                {{ deviceType.name }}
              </ng-option>
            </ng-select>
          </div>

          <div class="form-group" *ngIf="podeEscolherEmpresa">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="trading"> Empresa: </label>
            <ng-select
              notFoundText="Nenhum item encontrado"
              [searchable]="false"
              placeholder="Empresa"
              formControlName="companyId"
            >
              <ng-option *ngFor="let company of companies" [value]="company.id">
                {{ company.name }}
              </ng-option>
            </ng-select>
          </div>

          <div class="form-group" *ngIf="podeEscolherEmpresa">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="trading"> Setup: </label>
            <ng-select
              notFoundText="Nenhum item encontrado"
              [searchable]="false"
              placeholder="Setup"
              formControlName="setupId"
              [disabled]="1 === 1"
            >
              <ng-option *ngFor="let setup of setupsOptions" [value]="setup.id">
                {{ setup.name }}
              </ng-option>
            </ng-select>
          </div>

          <div class="form-group">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="trading">
              Identificador do Terminal de Pagamento:
            </label>
            <input
              type="text"
              class="form-input"
              placeholder="Identificador do Terminal de Pagamento"
              formControlName="paymentTerminalId"
            />
          </div>
        </div>

        <div class="form-group flex justify-end items-end">
          <button
            *isAllowed="[ERoleAdminString.Admin, 'device.edit']"
            alt="Salvar dispositivo"
            (click)="editDevice()"
            class="w-80 h-9 btn btn--secondary"
          >
            + Salvar dispositivo
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
